import moment from 'moment'
import { useGetQuotationStore } from '../../../Stores/useGetQuotationStore'
import { QUOTATION_STATUS } from '../../../constants/quotationStatusCode'
import { Row } from '../Row'
import { TabPageContainer } from '../styles'
import { SendDocuments } from './SendDocuments'

export const Messages = () => {
  const { getQuotation } = useGetQuotationStore()
  const TODAY = moment().format('DD-MM-YYYY HH[h]mm')

  return (
    <>
      <TabPageContainer>
        {getQuotation?.policyQuotation?.messages?.map((message) => (
          <Row
            title={message.author || ''}
            dateTime={moment(message.date).format('DD-MM-YYYY HH[h]mm') || ''}
            rightContent={
              <>
                <p className="text">{message.messageText}</p>
                {/* TODO: check if this status will be displayed */}
                <p className="text">
                  {
                    QUOTATION_STATUS[
                      getQuotation?.policyQuotation?.status as never
                    ]
                  }
                </p>
              </>
            }
          />
        ))}
        <Row dateTime={TODAY} rightContent={<SendDocuments />} />
      </TabPageContainer>
    </>
  )
}
